import React from 'react';
import PropTypes from 'prop-types';
import { DATETIME_FORMAT_DATE } from '../../../../../utils/helpers/CommonHelper';
import { DatePicker, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/sk';
import localeSK from 'antd/es/date-picker/locale/sk_SK';
import localeEN from 'antd/es/date-picker/locale/en_GB';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const RangeDatePicker = ({ value, name, label, ...rest }) => {
  const { t, i18n } = useTranslation();
  //  const valueFrom = value && value[0];
  //  const valueTo = value && value[1];
  //  component hold state by itself

  const locales = { sk: localeSK, en: localeEN };

  return (
    <Form.Item {...rest} name={name} label={label}>
      <RangePicker
        placeholder={[t('Od'), t('Do')]}
        // defaultValue={[
        //   valueFrom !== '' ? moment(valueFrom) : null,
        //   valueTo !== '' ? moment(valueTo) : null,
        // ]}
        format={DATETIME_FORMAT_DATE}
        locale={locales[i18n.language]}
        style={{ width: '100%' }}
        size="small"
        presets={[
          {
            label: t('Today'),
            value: [dayjs(), dayjs()],
          },
        ]}
        {...rest}
      />
    </Form.Item>
  );
};

RangeDatePicker.propTypes = {
  value: PropTypes.any, // [valueFrom, valueTo]
  onChange: PropTypes.any, // () => onChange([valueFrom, valueTo])
};

export default RangeDatePicker;
